const CONSENT_KEY = "cookie_consent";
const CONSENT_TTL_MS = 1000 * 60 * 60 * 24 * 30 * 6; // ~6 mois

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    const now = Date.now();

    if (!parsed?.expiresAt || now > parsed.expiresAt) {
      localStorage.removeItem(CONSENT_KEY);
      return null;
    }

    return parsed.value || null;
  } catch {
    return null;
  }
}

export function setConsent(value) {
  const now = Date.now();

  localStorage.setItem(
    CONSENT_KEY,
    JSON.stringify({
      value,
      savedAt: now,
      expiresAt: now + CONSENT_TTL_MS,
    })
  );

  window.dispatchEvent(new Event("consent-updated"));
}

export function clearConsent() {
  localStorage.removeItem(CONSENT_KEY);
  window.dispatchEvent(new Event("consent-updated"));
}